import styled, { createGlobalStyle } from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';


export const GlobalStyle = createGlobalStyle`
    body {
        position: relative;
        margin: 0;
        padding: 0;
        color: ${COLORS.TextPrimary};
        background-color: ${COLORS.BgMain};
    }

    * div {
        display: flex;
        flex-wrap: wrap;
    }
`;


export const AppContainer = styled.div<{ bgColor?: string }>`
    width: 100%;
    background-color: ${({ bgColor }) => bgColor ? bgColor : 'transparent'};
`;

export const Content = styled.div`
    position: relative;
    width: 100%;
    min-width: 320px;
    min-height: 100vh;
    margin-left: auto;
    padding-top: 0;
`;
